import { useMutation } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import { type CompanyEmployeeDetailsDto } from '@/api/generated/models/company-employee-details-dto';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useCompanyApiClient } from '@/api/util/useCompanyApiClient.util.ts';

type Req = {
  companyId: string;
  employeeId: string;
};

type Response = CompanyEmployeeDetailsDto;

type Return = {
  getUserCompanyEmployeeData: (req: Req) => Promise<Response>;
  isError: boolean;
  isGetting: boolean;
};

export const useGetUserCompanyEmployeeData = (): Return => {
  const { companyEmployeesApi } = useCompanyApiClient();

  const { isError, isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      const response = await companyEmployeesApi.getCompanyEmployee(req.companyId, req.employeeId);
      return response.data;
    },
    mutationKey: [QueryKeyEnum.USERS.COMPANY_EMPLOYEE],
  });

  return {
    getUserCompanyEmployeeData: mutateAsync,
    isError,
    isGetting: isPending,
  };
};
